import styled from "styled-components";

const Container = styled.div`
  border-radius: 30px;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  padding: 4px 7px 4px 20px;
  display: flex;
  align-items: center;

  input {
    border: none;
    outline: none;

    font-size: 14px;
  }
`;

export { Container };
